module.exports = __webpack_public_path__ + "static/media/reportedIcon.fbc67d04.svg";